export const PASSIO_DEFAULT_IMAGE =
"https://image.passio.eco/page-builder/page-builder/images-default/product-default.jpeg";